import React, { useEffect, useRef } from 'react';
import './SearchComponent.css'; // Import your CSS for transitions
import { charsNormalize } from '../Shared/charactorsNormalize';

function SearchComponent({searchTerm, setSearchTerm, isInputVisible, setInputVisible}) {
    const inputRef = useRef(null);

    const clickOnSearch = () => {
        setInputVisible(true);
    };

    const closeSearch = () => {
        setSearchTerm('')
        setInputVisible(false);
    };

    const handleSearchChange = (e) => {
        const value = charsNormalize(e.target.value);
        setSearchTerm(value)

    };

    useEffect(() => {
        isInputVisible && setTimeout(() => {
            inputRef.current.focus();
        }, 100);
    }, [isInputVisible])


    return (
        <div className="search_component">
            <button onClick={clickOnSearch} className='search_button'>
                <i className='fa fa-search'></i>
            </button>
            {isInputVisible && (
                <React.Fragment>
                    <input
                        type="text"
                        autoComplete='off'
                        ref={inputRef}
                        value={searchTerm}
                        onChange={handleSearchChange}
                        placeholder="جستجو کنید ..."
                        className={`search-input`}
                    />
                    <span
                        onClick={closeSearch}
                        style={{
                            width: '25px', height: '22px',
                            backgroundColor: 'transparent',
                            color: '#aaa',
                            position: 'relative',
                            left: '30px',
                            alignSelf: 'center',
                            cursor:'pointer',
                        }}>
                        <i className='fa fa-close' style={{ fontSize: '1.4rem' }}></i>
                    </span>
                </React.Fragment>
            )}
        </div>
    );
}

export default SearchComponent;
